import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux'

import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'

import ProductActionButton from './productActionButton';
import ImageActionButton from './imageActionButton'

import { getProduct } from '../../../redux/actions/productMasterActions';
import { FEATURES } from '../../../config/features';


function ProductTable(props) {
    
    const { productData, productLoading, getProduct } = props;

    useEffect(() => {
        getProduct()
    }, [getProduct]);


    if(productLoading){
        return (
            <React.Fragment>
                <TitleBar title="Product" LinkName="add-product" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else if (productData && productData.length === 0) {
        return (
            <React.Fragment>
                <TitleBar title="Product" LinkName="add-product" />
                <Segment className="m-2">
                    <center><Header>No Record(s) Found</Header></center>
                </Segment>
            </React.Fragment>
        )
    } else {

        let columnDefs = [
            { headerName: 'Image', field: 'img', tooltipField: 'img', cellRenderer: 'imageRenderer', width: 380, suppressToolPanel: true },
            { headerName: 'Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Product', field: 'product', tooltipField: 'product', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Category', field: 'category', tooltipField: 'category', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Weight', field: 'weight', tooltipField: 'weight', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Purchase Price', field: 'purchasePrice', tooltipField: 'purchasePrice', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Selling Price', field: 'sellingPrice', tooltipField: 'sellingPrice', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'GST%', field: 'gst', tooltipField: 'gst', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Current Stock', field: 'currentStock', tooltipField: 'currentStock', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Amount Balance', field: 'amountBalance', tooltipField: 'amountBalance', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Serial No.s', field: 'serial', cellRenderer: 'serialRenderer', width: 280, suppressToolPanel: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true }
        ] 
        
        let frameworkComponents = {
            actionRenderer: ProductActionButton,
            imageRenderer: ImageActionButton,
            // serialRenderer: SerialActionButton
        }

        let rowData = []

        productData && productData.forEach((object, index) => {
            let temp = {}
            temp.image = object.image
            temp.code = object.psCode
            temp.product = object.psDescription
            temp.category = object.categoryId
            temp.weight = object.weight ? object.weight : ''
            temp.purchasePrice = object.purchasePrice
            temp.sellingPrice = object.sellingPrice
            temp.gst = object.gstPercentage
            temp.currentStock = object.openingStock
            temp.amountBalance = ""
            rowData[index] = temp
        })
        

        return (
            <React.Fragment>
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={props.searchValue}
                        link="/add-product"
                        baseUrl={props}
                        hiddenNewPopupBtn={true}
                        hiddenImportPopupBtn={true}
                        extraComponents={frameworkComponents}
                        titleBarTitle="Product"
                        handleSearch={props.handleSearch}
                        exportHidden={FEATURES.mastersExportDisabled()}
                        suppressExcelExport={FEATURES.mastersExportDisabled()}
                        suppressCsvExport={FEATURES.mastersExportDisabled()}
                    />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    productData: state.productData.product.data,
    productLoading: state.productData.isLoading
})

export default connect(mapStatetoProps, { getProduct })(ProductTable)